export default {
    messages: {
        success: '',
        error: [],
        warning: '',
        validation: {}
    },
    auth: {
        user: {},
        token: null,
        refresh_token: null,
        token_expiration: null,
        abilities: [],
        project_abilities: [],
        settings: {},
        user_version: null
    },
    fetching: false,
    sidebar_logo_url: '',
    is_global_management_system: null,
    has_cl_only_features: null,
    system_locale: null,
    states: {
        latest_scroll_to_comment: null,
    },
    password_reset_enabled: null,
};



// WEBPACK FOOTER //
// ./src/store/state.js